export default __webpack_public_path__ + "static/media/mojeZdjecie.7d310c06.jpg";